module.exports = __webpack_public_path__ + "static/media/the_end.d755f248.png";